/**
 * The global state selectors
 */

import { createSelector } from 'reselect';

const selectGlobal = (state) => state.get('global');

const selectCurrentUser = (state) => state.get('currentUser');

const selectRoute = (state) => state.get('route');

const makeSelectCurrentUser = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('currentUser')
);

const makeSelectLoading = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('loading')
);

const makeSelectError = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('error')
);

const makeSelectRepos = () => createSelector(
  selectGlobal,
  (globalState) => globalState.getIn(['userData', 'repositories'])
);

const makeSelectLocation = () => createSelector(
  selectRoute,
  (routeState) => routeState.get('location').toJS()
);

const makeSelectWorkspaceTheme = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('workspaceTheme')
);

const makeSelectMobileSidebarOpen = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('mobileSidebarOpen')
);

const makeSelectNotificationBannerHeight = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('notificationBannerHeight')
);


const makeSelectAISummaryPanelOpen = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('aiSummaryPanelOpen')
);

const getReviewBanner = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('showReviewerBanner')
);

const getActivityIdAiSummary = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('activityId')
);

const getCurrentUser = () => createSelector(
  selectCurrentUser,
  (userState) => {
    const titles = userState.get('me');
    return titles.toJS();
  }
);

export {
  selectGlobal,
  makeSelectCurrentUser,
  makeSelectLoading,
  makeSelectError,
  makeSelectRepos,
  makeSelectLocation,
  makeSelectWorkspaceTheme,
  makeSelectMobileSidebarOpen,
  makeSelectNotificationBannerHeight,
  makeSelectAISummaryPanelOpen,
  getReviewBanner,
  getActivityIdAiSummary,
  getCurrentUser,
};
